/**
 * Sold Markers
 * 
 * @Author: Focci
 * @Date: 2023-07-10 10:13:27
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-10 10:13:27
 */

import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { propertyType, houseSearchType } from '@lib/config'
import Markers from './Markers'

export default function SoldMarkers({
  apiParam = null,
  ...markerProps
}) {
  const fetchParam = useMemo(() => ({ 
    ...apiParam,
    typeId: propertyType.SOLD,
  }), [apiParam])

  return (
    <Markers
      needGroup 
      param={fetchParam}
      type={houseSearchType.sold}
      markerStyle={{ zIndex: 3 }}
      {...markerProps}
    />
  )
}

SoldMarkers.propTypes = {
  apiParam: PropTypes.object,
}
